import { render, staticRenderFns } from "./BuyerTrafficControl.vue?vue&type=template&id=6fa43725&scoped=true"
import script from "./BuyerTrafficControl.vue?vue&type=script&lang=js"
export * from "./BuyerTrafficControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa43725",
  null
  
)

export default component.exports